// Shared CSV cell serialization for staff-facing exports.
//
// Two concerns, both applied per cell:
//  1. Formula-injection neutralization — spreadsheet apps (Excel, Google
//     Sheets) interpret a cell that starts with =, +, -, or @ as a formula.
//     Parent-supplied free text (names, notes) could otherwise smuggle a live
//     formula into a staff export. Prefix a single ' so it's read as literal text.
//  2. Quote-escaping — wrap in double quotes (doubling any inner quotes) when
//     the value contains a comma, quote, or newline.
//
// Order matters: neutralize first, then quote-escape, so a neutralized value
// containing a delimiter still gets quoted correctly.

function neutralizeFormula(s) {
	return /^[=+\-@]/.test(s) ? `'${s}` : s;
}

export function csvEscapeCell(v) {
	const s = neutralizeFormula(v == null ? '' : String(v));
	return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
